import { Insight, TrendDetail, TrendGroupDetail } from '@fullstory/proto/fs/api/proactiveinsights';
import { ObjectDeps } from '@fullstory/proto/fs/services/dx-objects';
import { int64 } from '@fullstory/proto/google/protobuf';

export enum InsightRequestTypes {
  AddCheckedForInsightsHash = 'insights.addCheckedForInsightsHash',
  GetInsightDetailViewRequest = 'insights.getInsightDetailView.request',
  GetInsightDetailViewSuccess = 'insights.getInsightDetailView.success',
  GetInsightDetailViewFailure = 'insights.getInsightDetailView.failure',
  GetInsightsRequest = 'insights.getInsights.request',
  GetInsightsSuccess = 'insights.getInsights.success',
  GetInsightsFailure = 'insights.getInsights.failure',
  RemoveCheckedForInsightsHash = 'insights.removeCheckedForInsightsHash',
}

export interface GetInsightsResp {
  insights: InsightDetail[];
}

export interface GetInsightDetailViewResp extends GetInsightsResp {
  deps: ObjectDeps | null;
}

export type InsightsById = { [id: string]: InsightDetail };
export type MetricInsightState = InsightsById;

export interface InsightDetail extends Insight {
  title: string;
  dxIdObjectHash: number;
  insightWords: InsightWords;
}

export interface InsightTrendDetail extends InsightDetail {
  trend: TrendDetail;
  insightWords: InsightTrendWords;
}

export interface InsightTrendGroupByDetail extends InsightDetail {
  trendGroup: TrendGroupDetail;
  insightWords: InsightTrendGroupByWords;
}

export type InsightWords = InsightTrendWords | InsightTrendGroupByWords;

export type InsightTrendWords = {
  isVolatilityTrend: boolean;
  isIncrease: boolean;
  ratioChangeI18l: string;
  isMonthly: boolean;
  numPreviousWeeks: number;
};

export type InsightTrendGroupByWords = {
  topValueIsIncrease: boolean;
  topValueRatioChange: string;
  gapValueIsIncrease: boolean;
  gapValueRatioChange: string;
};

export type IdentifyingMetricData = {
  id: string | undefined;
  version: int64 | undefined;
  isSaved: boolean;
};
